module.exports = __webpack_public_path__ + "Alex1-0485f487.png";